module.exports = __webpack_public_path__ + "img/united-states.95cf2213.svg";